import styled from "styled-components";

export const customStyles = {
  overlay: {
    backgroundColor: "#00000170",
  },
  content: {
    border: "none",
    background: "none",
    padding: "0",
  },
};
export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const CloseButton = styled.button`
  position: absolute;
  top: calc(var(--u) * 10);
  right: calc(var(--u) * 10);
  background: none;
  border: none;
  font-size: calc(var(--u) * 50);
  color: #ccc;
  cursor: pointer;
`;
export const ModalContent = styled.div`
  display: flex;
  height: 70%;
  width: 70%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: transparent;
`;
export const ModalHeader = styled.div<{ color: string }>`
  position: relative;
  width: 100%;
  height: 20%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: ${(props) => props.color};
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;
export const Logo = styled.img`
  position: absolute;
  left: calc(var(--u) * 10);
  width: calc(var(--u) * 75);
  height: calc(var(--u) * 75);
`;
export const ModalTitle = styled.h1`
  width: 100%;
  font-size: var(--fs-2xl);
  font-weight: bold;
  text-align: center;
  margin-top: var(--sp-10);
`;
export const ModalDescription = styled.p`
  width: 100%;
  font-size: var(--fs-base);
  text-align: center;
  margin-bottom: var(--sp-20);
`;
export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; // Add this
  width: 100%;
  height: 90%;
  background-color: #c0cdfd;
  padding-top: var(--sp-10);
`;
export const RowContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center; // Add this
`;
export const FieldContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center; // Change this from justify-items to justify-content
  margin-bottom: var(--sp-10);
`;
export const FieldLabel = styled.label`
  margin-top: var(--sp-5);
  margin-right: var(--sp-10);
  font-size: var(--fs-base);
`;
export const TextInput = styled.div<{ color: string }>`
  width: calc(var(--u) * 300);
  font-size: var(--fs-base);
  position: relative;
  border: 1.5px solid ${(props) => props.color};
  border-radius: 6px;
  margin-right: var(--sp-10);
  input {
    width: 100%;
    font-size: var(--fs-base);
    padding: var(--sp-4) var(--sp-2) var(--sp-2) var(--sp-4);
    border: 1.5px solid #bbbbbb;
    border-radius: 5px;
    outline: unset;
    transition: outline 0.2s ease;
  }

  input:focus {
    box-shadow: 0 0 0 1px #e8e8e8, 0 0 0 3px ${(props) => props.color};
  }

  label {
    padding: 0 var(--sp-5);
    transition: all 0.1s ease-in-out;
    position: absolute;
    top: 50%;
    left: calc(var(--u) * 10);
    transform: translateY(-50%);
    pointer-events: none;
    background: #ffffff;
    border-radius: 5px;
  }

  input:focus ~ label,
  input:not(:placeholder-shown) ~ label {
    top: calc(var(--u) * 10);
    left: 0px;
    transform: scale(0.85) translateY(-120%);
    background: ${(props) => props.color};
    color: white;
  }
`;
export const NumberInput = styled.div<{ color: string }>`
  width: calc(var(--u) * 150);
  font-size: var(--fs-base);
  position: relative;
  border: 1.5px solid ${(props) => props.color};
  border-radius: 6px;
  input {
    width: 100%;
    font-size: var(--fs-base);
    padding: var(--sp-4) var(--sp-2) var(--sp-2) var(--sp-4);
    border: 1.5px solid #bbbbbb;
    border-radius: 5px;
    outline: unset;
    transition: outline 0.2s ease;
  }

  input:focus {
    box-shadow: 0 0 0 1px #e8e8e8, 0 0 0 3px ${(props) => props.color};
  }

  label {
    transition: all 0.1s ease-in-out;
    color: #2c2c54;
    position: absolute;
    top: 50%;
    left: calc(var(--u) * 10);
    transform: translateY(-50%);
    pointer-events: none;
    background: white;
    padding: 0 var(--sp-5);
    border-radius: 5px;
  }

  input:focus ~ label,
  input:not(:placeholder-shown) ~ label {
    top: calc(var(--u) * 10);
    left: 0px;
    transform: scale(0.85) translateY(-120%);
    background: ${(props) => props.color};
    color: white;
  }
`;
export const Unit = styled.span<{ color: string }>`
  position: relative;
  font-size: var(--fs-base);
  opacity: 0.8;
  color: ${(props) => props.color};
  font-weight: bold;
  right: 45%;
`;
export const DropDown = styled.select<{ color: string }>`
  width: 100%;
  padding: var(--sp-10);
  margin-bottom: var(--sp-10);
  border: 1.5px solid ${(props) => props.color};
  border-radius: 6px;
`;
export const Button = styled.button`
  width: fit-content;
  height: calc(var(--u) * 40);
  background-color: white;
  opacity: 0.7;
  color: black;
  border: none;
  border-radius: 12px;
  font-size: var(--fs-xl);
  font-weight: bold;
  cursor: pointer;
  padding: 0 var(--sp-20);
  margin: var(--sp-10);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  &:hover {
    opacity: 1;
  }
`;

export const ModalFooter = styled.div<{ color: string }>`
  position: relative;
  width: 100%;
  height: 20%;
  display: flex;
  align-items: center;
  justify-content: space-between; // Change this from center to space-between
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: ${(props) => props.color};
`;
export const CustomerTable = styled.table`
  width: 100%;
  overflow-y: auto;
  border-collapse: collapse;
  th,
  td {
    padding: var(--sp-5);
    text-align: center;
  }
  th {
    background-color: #000000cc;
    color: #fff;
    font-size: var(--fs-base);
    font-weight: bold;
    position: sticky;
    top: 0;
  }
  td {
    background-color: #fff;
    border: 0.5px solid #000;
    font-size: var(--fs-base);
    font-weight: bold;
  }
`;
export const TableContainer = styled.div`
    width: 95%;
    height: calc(var(--u) * 300);/* Ajuste conforme necessário */
  margin-bottom: var(--sp-10);
  overflow-y: auto;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);

  table {
    width: 100%;
    border-collapse: collapse;

    thead {
      position: sticky;
      top: 0;
      background-color: #4a90e2;
      color: #fff;
      text-align: left;
      font-weight: bold;

      th {
        padding: var(--sp-12);
        font-size: var(--fs-md);
      }
    }

    tbody {
      tr {
        cursor: pointer;

        &:nth-child(even) {
          background-color: #f9f9f9;
        }

        &:hover {
          background-color: #e6f7ff;
        }
      }

      td {
        padding: var(--sp-12);
        font-size: var(--fs-md);
        border-bottom: 1px solid #ddd;
      }
    }
  }
`;